var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"dense":"","nav":""}},_vm._l((_vm.facebook.accounts),function(account){return _c('v-list-item',{key:account.id,attrs:{"link":"","to":{
      name: 'facebook-campaings',
      params: { accountId: account.id }
    }}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-folder-multiple-outline")])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(account.name))]),_c('v-list-item-subtitle',[_vm._v(_vm._s(account.account_id))])],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }